import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class HorizontalScroll {
  constructor(element) {
    this.element = element;
    this.viewport = element.querySelector('.horizontal-scroll-section__sticky-viewport');
    this.content = element.querySelector('.horizontal-scroll-section__content');
    
    if (this.viewport && this.content) {
      this.init();
    }
  }

  init() {
    // Calculate total width of content
    const getScrollAmount = () => {
      let contentWidth = this.content.scrollWidth;
      let viewportWidth = this.viewport.offsetWidth;
      return -(contentWidth - viewportWidth);
    };

    // Add buffer zones at start and end (as percentage of viewport height)
    const startBuffer = window.innerHeight * 0.3;  // 30% viewport height pause at start
    const endBuffer = window.innerHeight * 0.5;    // 50% viewport height pause at end
    
    // Create timeline with pauses at start and end
    const tl = gsap.timeline({
      scrollTrigger: {
        id: "horizontal-scroll",
        trigger: this.element,
        start: "top top",
        end: () => `+=${getScrollAmount() * -1 + startBuffer + endBuffer}`,
        pin: true,
        scrub: 1,
        invalidateOnRefresh: true,
        refreshPriority: 1,
        markers: false
      }
    });
    
    // Add pause at start (as percentage of total timeline)
    const totalDuration = 100;
    const startPausePercent = (startBuffer / (getScrollAmount() * -1 + startBuffer + endBuffer)) * totalDuration;
    const endPausePercent = (endBuffer / (getScrollAmount() * -1 + startBuffer + endBuffer)) * totalDuration;
    
    tl.to(this.content, {
      x: 0,
      duration: startPausePercent,
      ease: "none"
    })
    .to(this.content, {
      x: getScrollAmount,
      duration: totalDuration - startPausePercent - endPausePercent,
      ease: "none"
    })
    .to(this.content, {
      x: getScrollAmount,
      duration: endPausePercent,
      ease: "none"
    });

    this.tween = tl;
    
    // Store reference globally for animations
    if (!window.horizontalScrollTween) {
      window.horizontalScrollTween = this.tween;
    }
    
    // Refresh all ScrollTriggers after horizontal scroll initializes
    // This fixes positioning issues for animations that come after this section
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 100);
  }
}

export default HorizontalScroll;
